import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { NavigateNext as NavigateNextIcon } from "@mui/icons-material";

/**
 * Breadcrumbs component for agent detail pages
 * Shows: ClientName / Agents / AgentID
 */
export default function AgentBreadcrumbs({ agentId }) {
  const navigate = useNavigate();
  const currentApp = useSelector((state) => state?.apps?.selectedApp);

  if (!currentApp || !agentId) {
    return null;
  }

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ mb: 2 }}
    >
      <Link
        underline="hover"
        color="inherit"
        href={`/${currentApp.url_code}/`}
        onClick={(e) => {
          e.preventDefault();
          navigate(`/${currentApp.url_code}/`);
        }}
        sx={{ cursor: 'pointer' }}
      >
        {currentApp.client_name}
      </Link>
      <Link
        underline="hover"
        color="inherit"
        href={`/${currentApp.url_code}/`}
        onClick={(e) => {
          e.preventDefault();
          navigate(`/${currentApp.url_code}/`);
        }}
        sx={{ cursor: 'pointer' }}
      >
        Agents
      </Link>
      <Typography color="text.primary">{agentId}</Typography>
    </Breadcrumbs>
  );
}
